"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parserStringLiteral = void 0;
const parserStringLiteral = (BaseClass) => {
    const DerivedClass = class extends BaseClass {
        visitStringExpression(ctx) {
            return this.visitString(ctx.string());
        }
        visitString(ctx) {
            return {
                type: 'StringLiteral',
                string: ctx.StringLiteral().toString()
            };
        }
    };
    return DerivedClass;
};
exports.parserStringLiteral = parserStringLiteral;
//# sourceMappingURL=stringParser.js.map